module.exports = __webpack_public_path__ + "img/shy.8dc993bc.gif";